import { format, lastDayOfMonth } from 'date-fns';
import User from '../auth/User';

const TIME_OUT = 30000;

const execApi = async (url, request, token = null) => {
  const payload = {
    accesskey: process.env.REACT_APP_ACCESS_KEY,
    request: request,
  };

  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers['X-Authorization'] = token;
  }

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), TIME_OUT);

  const config = {
    method: 'post',
    url,
    headers,
    data: JSON.stringify(payload),
    timeout: TIME_OUT,
  };

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: config.data,
      signal: controller.signal,
    });

    const text = await res.text();
    let data;
    try {
      data = text ? JSON.parse(text) : null;
    } catch {
      data = text;
    }

    return {
      data,
      status: res.status,
      statusText: res.statusText,
      config,
      headers: Object.fromEntries(res.headers.entries()),
      request: null,
    };
  } finally {
    clearTimeout(timeoutId);
  }
};

export const fetchServiceCount = async (targetDate = new Date()) => {
  const url = process.env.REACT_APP_URL_SERVICE_COUNT;
  const request = {
    begindate: format(targetDate, 'yyyy-MM-01'),
    enddate: format(lastDayOfMonth(targetDate), 'yyyy-MM-dd'),
  };
  const token = await User.accessToken();

  return execApi(url, request, token);
};

export const fetchScheduleDay = async (selectedDate = new Date()) => {
  const url = process.env.REACT_APP_URL_SCHEDULE;
  const request = {
    begindate: format(selectedDate, 'yyyy-MM-dd'),
    enddate: format(selectedDate, 'yyyy-MM-dd'),
  };
  const token = await User.accessToken();

  return execApi(url, request, token);
};

export const fetchScheduleMonth = async (targetDate = new Date()) => {
  const url = process.env.REACT_APP_URL_SCHEDULE;
  const request = {
    begindate: format(targetDate, 'yyyy-MM-01'),
    enddate: format(lastDayOfMonth(targetDate), 'yyyy-MM-dd'),
  };
  const token = await User.accessToken();

  return execApi(url, request, token);
};

export const fetchKirokuItem = async (serviceId) => {
  const url = process.env.REACT_APP_URL_KIROKU;
  const request = {
    service_id: serviceId,
  };
  const token = await User.accessToken();

  return execApi(url, request, token);
};

export const postKirokuItem = async (serviceId, kirokuItem) => {
  const url = process.env.REACT_APP_URL_UPDKIROKU;
  const request = {
    service_id: serviceId,
    kiroku: kirokuItem,
  };
  const token = await User.accessToken();

  return execApi(url, request, token);
};

export const changePassword = async (oldPass, newPass) => {
  const url = process.env.REACT_APP_URL_PASS_CHANGE;
  const request = {
    oldpassword: oldPass,
    newpassword: newPass,
  };
  const token = await User.accessToken();

  return execApi(url, request, token);
};

export const changeMailAddress = async (newMail) => {
  const url = process.env.REACT_APP_URL_MAIL_CHANGE;
  const request = {
    mailaddress: newMail,
  };
  const token = await User.accessToken();

  return execApi(url, request, token);
};

export const forgotPassword = async (email) => {
  const url = process.env.REACT_APP_URL_PASS_FORGOT;
  const request = {
    mailaddress: email,
  };

  return execApi(url, request);
};

export const beginService = async (serviceId, lat, lon, cancel = false) => {
  const url = process.env.REACT_APP_URL_SERVICE_BEGIN;
  const request = {
    service_id: serviceId,
    lat: lat,
    lon: lon,
    cancel: cancel,
  };
  const token = await User.accessToken();

  return execApi(url, request, token);
};

export const endService = async (serviceId, lat, lon, cancel = false) => {
  const url = process.env.REACT_APP_URL_SERVICE_END;
  const request = {
    service_id: serviceId,
    lat: lat,
    lon: lon,
    cancel: cancel,
    state: '予定通り実施',
  };
  const token = await User.accessToken();

  return execApi(url, request, token);
};

export const NOTE_MAX_SIZE = 7;

export const fetchNote = async (serviceId) => {
  const url = process.env.REACT_APP_URL_NOTE;
  const request = {
    service_id: serviceId,
    size: NOTE_MAX_SIZE,
  };
  const token = await User.accessToken();

  return execApi(url, request, token);
};

export const fetchCustomer = async (serviceId) => {
  const url = process.env.REACT_APP_URL_RIYOUSHA;
  const request = {
    service_id: serviceId,
  };
  const token = await User.accessToken();

  return execApi(url, request, token);
};

export const fetchOrder = async (serviceId) => {
  const url = process.env.REACT_APP_URL_ORDER;
  const request = {
    service_id: serviceId,
  };
  const token = await User.accessToken();

  return execApi(url, request, token);
};

export const fetchRunbook = async (serviceId) => {
  const url = process.env.REACT_APP_URL_RUNBOOK;
  const request = {
    service_id: serviceId,
  };
  const token = await User.accessToken();

  return execApi(url, request, token);
};

export const NOTIFICATION_MAX_SIZE = 7;

export const fetchNotification = async (infoId) => {
  const url = process.env.REACT_APP_URL_NOTIFICATION;
  const request = {
    info_id: infoId,
    size: NOTIFICATION_MAX_SIZE,
  };
  const token = await User.accessToken();

  return execApi(url, request, token);
};
